/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ForgotRouteImport } from './routes/forgot'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AppWishesRouteImport } from './routes/app.wishes'
import { Route as AppRecordsRouteImport } from './routes/app.records'
import { Route as AppMeRouteImport } from './routes/app.me'
import { Route as AppLedgerRouteImport } from './routes/app.ledger'
import { Route as AppHomeRouteImport } from './routes/app.home'
import { Route as AppWishesIdRouteImport } from './routes/app.wishes.$id'
import { Route as AppRecordsIdRouteImport } from './routes/app.records.$id'
import { Route as AppWishesIdRedeemRouteImport } from './routes/app.wishes.$id.redeem'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotRoute = ForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppWishesRoute = AppWishesRouteImport.update({
  id: '/wishes',
  path: '/wishes',
  getParentRoute: () => AppRoute,
} as any)
const AppRecordsRoute = AppRecordsRouteImport.update({
  id: '/records',
  path: '/records',
  getParentRoute: () => AppRoute,
} as any)
const AppMeRoute = AppMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppRoute,
} as any)
const AppLedgerRoute = AppLedgerRouteImport.update({
  id: '/ledger',
  path: '/ledger',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppWishesIdRoute = AppWishesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppWishesRoute,
} as any)
const AppRecordsIdRoute = AppRecordsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppRecordsRoute,
} as any)
const AppWishesIdRedeemRoute = AppWishesIdRedeemRouteImport.update({
  id: '/redeem',
  path: '/redeem',
  getParentRoute: () => AppWishesIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/forgot': typeof ForgotRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app/home': typeof AppHomeRoute
  '/app/ledger': typeof AppLedgerRoute
  '/app/me': typeof AppMeRoute
  '/app/records': typeof AppRecordsRouteWithChildren
  '/app/wishes': typeof AppWishesRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/app/records/$id': typeof AppRecordsIdRoute
  '/app/wishes/$id': typeof AppWishesIdRouteWithChildren
  '/app/wishes/$id/redeem': typeof AppWishesIdRedeemRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot': typeof ForgotRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app/home': typeof AppHomeRoute
  '/app/ledger': typeof AppLedgerRoute
  '/app/me': typeof AppMeRoute
  '/app/records': typeof AppRecordsRouteWithChildren
  '/app/wishes': typeof AppWishesRouteWithChildren
  '/app': typeof AppIndexRoute
  '/app/records/$id': typeof AppRecordsIdRoute
  '/app/wishes/$id': typeof AppWishesIdRouteWithChildren
  '/app/wishes/$id/redeem': typeof AppWishesIdRedeemRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/forgot': typeof ForgotRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app/home': typeof AppHomeRoute
  '/app/ledger': typeof AppLedgerRoute
  '/app/me': typeof AppMeRoute
  '/app/records': typeof AppRecordsRouteWithChildren
  '/app/wishes': typeof AppWishesRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/app/records/$id': typeof AppRecordsIdRoute
  '/app/wishes/$id': typeof AppWishesIdRouteWithChildren
  '/app/wishes/$id/redeem': typeof AppWishesIdRedeemRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/forgot'
    | '/reset-password'
    | '/app/home'
    | '/app/ledger'
    | '/app/me'
    | '/app/records'
    | '/app/wishes'
    | '/app/'
    | '/app/records/$id'
    | '/app/wishes/$id'
    | '/app/wishes/$id/redeem'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot'
    | '/reset-password'
    | '/app/home'
    | '/app/ledger'
    | '/app/me'
    | '/app/records'
    | '/app/wishes'
    | '/app'
    | '/app/records/$id'
    | '/app/wishes/$id'
    | '/app/wishes/$id/redeem'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/forgot'
    | '/reset-password'
    | '/app/home'
    | '/app/ledger'
    | '/app/me'
    | '/app/records'
    | '/app/wishes'
    | '/app/'
    | '/app/records/$id'
    | '/app/wishes/$id'
    | '/app/wishes/$id/redeem'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotRoute: typeof ForgotRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot': {
      id: '/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof ForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/wishes': {
      id: '/app/wishes'
      path: '/wishes'
      fullPath: '/app/wishes'
      preLoaderRoute: typeof AppWishesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/records': {
      id: '/app/records'
      path: '/records'
      fullPath: '/app/records'
      preLoaderRoute: typeof AppRecordsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/me': {
      id: '/app/me'
      path: '/me'
      fullPath: '/app/me'
      preLoaderRoute: typeof AppMeRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/ledger': {
      id: '/app/ledger'
      path: '/ledger'
      fullPath: '/app/ledger'
      preLoaderRoute: typeof AppLedgerRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/home': {
      id: '/app/home'
      path: '/home'
      fullPath: '/app/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/wishes/$id': {
      id: '/app/wishes/$id'
      path: '/$id'
      fullPath: '/app/wishes/$id'
      preLoaderRoute: typeof AppWishesIdRouteImport
      parentRoute: typeof AppWishesRoute
    }
    '/app/records/$id': {
      id: '/app/records/$id'
      path: '/$id'
      fullPath: '/app/records/$id'
      preLoaderRoute: typeof AppRecordsIdRouteImport
      parentRoute: typeof AppRecordsRoute
    }
    '/app/wishes/$id/redeem': {
      id: '/app/wishes/$id/redeem'
      path: '/redeem'
      fullPath: '/app/wishes/$id/redeem'
      preLoaderRoute: typeof AppWishesIdRedeemRouteImport
      parentRoute: typeof AppWishesIdRoute
    }
  }
}

interface AppRecordsRouteChildren {
  AppRecordsIdRoute: typeof AppRecordsIdRoute
}

const AppRecordsRouteChildren: AppRecordsRouteChildren = {
  AppRecordsIdRoute: AppRecordsIdRoute,
}

const AppRecordsRouteWithChildren = AppRecordsRoute._addFileChildren(
  AppRecordsRouteChildren,
)

interface AppWishesIdRouteChildren {
  AppWishesIdRedeemRoute: typeof AppWishesIdRedeemRoute
}

const AppWishesIdRouteChildren: AppWishesIdRouteChildren = {
  AppWishesIdRedeemRoute: AppWishesIdRedeemRoute,
}

const AppWishesIdRouteWithChildren = AppWishesIdRoute._addFileChildren(
  AppWishesIdRouteChildren,
)

interface AppWishesRouteChildren {
  AppWishesIdRoute: typeof AppWishesIdRouteWithChildren
}

const AppWishesRouteChildren: AppWishesRouteChildren = {
  AppWishesIdRoute: AppWishesIdRouteWithChildren,
}

const AppWishesRouteWithChildren = AppWishesRoute._addFileChildren(
  AppWishesRouteChildren,
)

interface AppRouteChildren {
  AppHomeRoute: typeof AppHomeRoute
  AppLedgerRoute: typeof AppLedgerRoute
  AppMeRoute: typeof AppMeRoute
  AppRecordsRoute: typeof AppRecordsRouteWithChildren
  AppWishesRoute: typeof AppWishesRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppHomeRoute: AppHomeRoute,
  AppLedgerRoute: AppLedgerRoute,
  AppMeRoute: AppMeRoute,
  AppRecordsRoute: AppRecordsRouteWithChildren,
  AppWishesRoute: AppWishesRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotRoute: ForgotRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
